import { render } from "./FactsStepBlock.vue?vue&type=template&id=23a7837b"
import script from "./FactsStepBlock.vue?vue&type=script&lang=js"
export * from "./FactsStepBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__